export default __webpack_public_path__ + "static/media/like_selected.3c6ff48e.svg";